import { render, staticRenderFns } from "./company-compliance-details-approval-container.vue?vue&type=template&id=7de8fec6&scoped=true&lang=pug"
import script from "./company-compliance-details-approval-container.vue?vue&type=script&lang=ts"
export * from "./company-compliance-details-approval-container.vue?vue&type=script&lang=ts"
import style0 from "./company-compliance-details-approval-container.vue?vue&type=style&index=0&id=7de8fec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de8fec6",
  null
  
)

export default component.exports